import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1B5E20] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_african-agro-export/artifacts/mgbf4mm8_folalabi%20farm%20logo.png" 
                alt="Folalabi Farms Logo" 
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-sm text-white/80 mb-4">
              International agricultural production and export company specializing in high-quality African food produce.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 bg-white/10 hover:bg-[#C8A951] rounded-full flex items-center justify-center transition-colors">
                <Facebook size={16} />
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 hover:bg-[#C8A951] rounded-full flex items-center justify-center transition-colors">
                <Linkedin size={16} />
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 hover:bg-[#C8A951] rounded-full flex items-center justify-center transition-colors">
                <Twitter size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-white/80 hover:text-[#C8A951] transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-[#C8A951] transition-colors">About Us</Link></li>
              <li><Link to="/products" className="text-white/80 hover:text-[#C8A951] transition-colors">Our Products</Link></li>
              <li><Link to="/export-logistics" className="text-white/80 hover:text-[#C8A951] transition-colors">Export & Logistics</Link></li>
              <li><Link to="/quality" className="text-white/80 hover:text-[#C8A951] transition-colors">Quality Assurance</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Products</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products/premium-yams" className="text-white/80 hover:text-[#C8A951] transition-colors">Premium Yams</Link></li>
              <li><Link to="/products/cassava-leaves" className="text-white/80 hover:text-[#C8A951] transition-colors">Fresh Cassava Leaves</Link></li>
              <li><Link to="/products/palm-oil" className="text-white/80 hover:text-[#C8A951] transition-colors">Pure Palm Oil</Link></li>
              <li><Link to="/partner" className="text-white/80 hover:text-[#C8A951] transition-colors">Partner With Us</Link></li>
              <li><Link to="/quote" className="text-white/80 hover:text-[#C8A951] transition-colors">Request Quote</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 text-[#C8A951] flex-shrink-0" />
                <span className="text-white/80">
                  <strong>Nigeria Office:</strong><br />
                  Ogun State, Ota, Nigeria
                </span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 text-[#C8A951] flex-shrink-0" />
                <span className="text-white/80">
                  <strong>UK Office:</strong><br />
                  United Kingdom
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#C8A951] flex-shrink-0" />
                <div className="text-white/80">
                  <a href="tel:+2349038145272" className="hover:text-[#C8A951] transition-colors block">
                    Nigeria: +234 903 814 5272
                  </a>
                  <a href="tel:+447803174494" className="hover:text-[#C8A951] transition-colors block">
                    UK: +44 7803 174494
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#C8A951] flex-shrink-0" />
                <div className="text-white/80">
                  <a href="mailto:admin@folalabifarms.com" className="hover:text-[#C8A951] transition-colors block">
                    admin@folalabifarms.com
                  </a>
                  <a href="mailto:info@folalabifarms.com" className="hover:text-[#C8A951] transition-colors block">
                    info@folalabifarms.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-6 text-center text-sm text-white/80">
          <p>&copy; {new Date().getFullYear()} Folalabi Farms Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
